// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"640545f4","172":"d47b3660","190":"69f7e038","664":"9560d417","673":"825c4eaf","793":"cdfbc332","866":"18f4011e","935":"3e8609bc","970":"52559982"}[chunkId] + ".css";
};